<nav class="navbar navbar-expand-sm menu-bar justify-content-between">
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link action-menu" (click)="newContact($event)">New Contact</a>
    </li>
    <li class="nav-item">
      <a class="nav-link action-menu" (click)="delete($event)">Delete</a>
    </li>
    <li class="nav-item">
      <a class="nav-link action-menu" (click)="merge($event)">Merge</a>
    </li>
    <li class="nav-item">
      <a class="nav-link action-menu" (click)="sms($event)">SMS</a>
    </li>
    <li class="nav-item">
      <a class="nav-link action-menu" (click)="email($event)">Email</a>
    </li>
  </ul>
  <form class="form-inline">
    <input class="form-control filter" type="search" placeholder="Search">
  </form>

</nav>

<div class="card card-default mt-3">
  <div class="card-header">
    <h3 class="card-title text-cust-blue">Contact List</h3>
  </div>
  <!-- /.card-header -->
  <div class="card-body p-0">
    <table id="example2" style="width:100%" class="table table-bordered table-hover result-table">
      <thead>
        <tr>
          <th class="col-checked">
            <label class="checktable">
              <input type="checkbox" id="cbsearchAll">
              <span class="checkmark"></span>
            </label>
          </th>
          <th>ผู้ติดต่อ</th>
          <th>หมายเลขโทรศัพท์</th>
          <th>Origin Source</th>
          <th>ผู้สร้างข้อมูล</th>
          <th>Create on</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="col-checked">
            <label class="checktable">
              <input type="checkbox" id="cbsearch1">
              <span class="checkmark"></span>
            </label>
          </td>
          <td>ทองดี อยู่เย็น</td>
          <td>094605015</td>
          <td>Call center</td>
          <td>Agent 5</td>
          <td>24 Oct 2020</td>
        </tr>

        <tr>
          <td class="col-checked">
            <label class="checktable">
              <input type="checkbox" id="cbsearch1">
              <span class="checkmark"></span>
            </label>
          </td>
          <td>ทองเป็น อยู่ดี</td>
          <td>0946056458</td>
          <td>Call center</td>
          <td>Agent 1</td>
          <td>08 Aug 2020</td>
        </tr>

        <tr>
          <td class="col-checked">
            <label class="checktable">
              <input type="checkbox" id="cbsearch2">
              <span class="checkmark"></span>
            </label>
          </td>
          <td>ทองมี ศรีกุก</td>
          <td>0946256458</td>
          <td>Call center</td>
          <td>Agent 1</td>
          <td>20 Dec 2019</td>
        </tr>

        <tr>
          <td class="col-checked">
            <label class="checktable">
              <input type="checkbox" id="cbsearch3">
              <span class="checkmark"></span>
            </label>
          </td>
          <td>ทองสุข มาก</td>
          <td>0846256458</td>
          <td>Call center</td>
          <td>Agent 21</td>
          <td>13 Jan 2020</td>
        </tr>

        <tr>
          <td class="col-checked">
            <label class="checktable">
              <input type="checkbox" id="cbsearch4">
              <span class="checkmark"></span>
            </label>
          </td>
          <td>ทองสุข มากมาย</td>
          <td>08462456458</td>
          <td>Call center</td>
          <td>Agent 2</td>
          <td>03 Jan 2020</td>
        </tr>

      </tbody>
    </table>
  </div>

</div>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        ...
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Merge-->
<div class="modal fade" id="mergeModal" tabindex="-1" role="dialog" aria-labelledby="mergeModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="mergeModalLabel">Select Contact</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5 text-right">
            <label>เลือก Contact หลัก</label>
          </div>
          <div class="col-7">
            <select class="form-control select2">
              <option>ทองดี อยู่เย็น</option>
              <option>ทองเย็น อยู่ดี</option>
              <option>ทองมี มากสุข</option>
              <option>ทองสุข มากมี</option>
            </select>
          </div>

          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-ok mr-2" (click)="confirmMerge()">OK</button>
            <button type="button" class="btn btn-cancel ml-2" (click)="CloseModal('mergeModal')">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal SMS-->
<div class="modal fade" id="smsModal" tabindex="-1" role="dialog" aria-labelledby="smsModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="smsModalLabel">Select SMS template</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5 text-right">
            <label>เลือก SMS Template</label>
          </div>
          <div class="col-7">
            <select class="form-control select2">
            </select>
          </div>

          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-ok mr-2" (click)="confirmSMS()">OK</button>
            <button type="button" class="btn btn-cancel ml-2" (click)="CloseModal('smsModal')">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Email-->
<div class="modal fade" id="emailModal" tabindex="-1" role="dialog" aria-labelledby="emailModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="emailModalLabel">Select Email template</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5 text-right">
            <label>เลือก Email Template</label>
          </div>
          <div class="col-7">
            <select class="form-control select2">
            </select>
          </div>

          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-ok mr-2" (click)="confirmEmail()">OK</button>
            <button type="button" class="btn btn-cancel ml-2" (click)="CloseModal('emailModal')">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Detail-->
<div class="modal fade" id="detailModal" tabindex="-1" role="dialog" aria-labelledby="detailModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-body p-0">
        <div class="row bg-img-top-menu">
          <div class="col-12 my-auto">
            <!-- Nav pills -->
            <ul class="nav nav-pills">
              <li class="nav-item">
                <a class="nav-link tab-menu active" data-toggle="pill" href="#CustomerProfile">
                  <span class="fa fa-user fa-lg"></span>
                  Customer Profile
                </a>
              </li>
              <li class="nav-item ml-3">
                <a class="nav-link tab-menu" data-toggle="pill" href="#Details">
                  <span class="fa fa-list fa-lg"></span>
                  Details
                </a>
              </li>
              <li class="nav-item ml-3">
                <a class="nav-link tab-menu" data-toggle="pill" href="#ContactReport">
                  <span class="fa fa-file-alt fa-lg"></span>
                  รายงานการติดต่อ
                </a>
              </li>
              <li class="nav-item ml-3">
                <a class="nav-link tab-menu" data-toggle="pill" href="#Depositor">
                  <span class="fa fa-address-card fa-lg"></span>
                  ข้อมูลผู้ฝาก
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-body-container">
          <div class="row mt-3">
            <div class="col-12 p-0">
              <div class="tab-content">
                <div class="tab-pane container p-0 active" id="CustomerProfile">
                  <div class="row">
                    <div class="col-3 section-label">
                      <h6 class="m-0">Verify</h6>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-3 text-right two-row-lbl">
                      <label>หมายเลขบัตรประชาชน/</label>
                      <br>
                      <label>เลขประจำตัวผู้เสียภาษี</label>
                    </div>
                    <div class="col-3">
                      <input type="text" class="form-control">
                    </div>
                    <div class="col-3 text-right">
                      <label>ประเภทเลขที่รหัสผู้ฝาก</label>
                    </div>
                    <div class="col-3">
                      <input type="text" class="form-control" style="background-color: #FFDDD1;">
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-3 text-right">
                      <label>ที่อยู่ที่ติดต่อได้ที่ให้ไว้กับ สง.</label>
                    </div>
                    <div class="col-9">
                      <input type="text" class="form-control">
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-3 text-right">
                      <label>จำนวนบัญชีเงินฝาก</label>
                    </div>
                    <div class="col-3">
                      <input type="text" class="form-control">
                    </div>
                    <div class="col-3 text-right">
                      <label>เบอร์โทรศัพท์ที่ให้ไว้กับ สง.</label>
                    </div>
                    <div class="col-3">
                      <input type="text" class="form-control">
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-11 mx-auto text-center">
                      <label>เคย Login Web Portal ผ่าน</label>
                      <label class="ml-5">
                        <input type="checkbox">
                        NDID
                      </label>
                      <label class="ml-5">
                        <input type="checkbox">
                        DOPA
                      </label>
                      <label class="ml-5">
                        <input type="checkbox">
                        Agent Bank
                      </label>
                    </div>
                  </div>

                  <hr>

                  <div class="row"></div>

                </div>
                <div class="tab-pane container p-0 fade" id="Details">...</div>
                <div class="tab-pane container p-0 fade" id="ContactReport">...</div>
                <div class="tab-pane container p-0 fade" id="Depositor">...</div>
              </div>
            </div>
          </div>
          <div class="row mt-5 pb-5">
            <div class="col-12 text-center">
              <button type="button" class="btn btn-cancel" (click)="CloseModal('detailModal')">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/contact/contact.component.html